<template>
  <div>
    <breadcrumb v-if="statu !== 3" :list="breadcrumbList"></breadcrumb>
    <el-card class="main">
      <el-row type="flex" class="title">
        <img src="@/assets/img/tag.png" alt="">
        <span class="title_text">场所标准地址</span>
      </el-row>
      <div>
        <el-row>
          <el-form :model="areaform" :rules="arearules" ref="areaform" label-width="120px">
            <el-row style="height:57px">
              <el-col :span="6">
                <el-form-item label="行政区划" prop="hi_xzqhbm">
                  <el-col :span="24">
                    <el-select style="width:100%" v-model.trim="areaform.hi_xzqhbm" placeholder="" @change="handleMap"
                      filterable remote>
                      <el-option v-for="item in xzqhList" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="街路巷" prop="jlx">
                  <el-col :span="24">
                    <el-select style="width:100%" v-model.trim="areaform.jlx" placeholder="" filterable remote
                      v-loadmore="more" :remote-method="remoteMethod" reserve-keyword @change="Pgs">
                      <el-option v-for="(item, index) in jlxList" :key="index" :label="`${item.jlxmc}-${item.dwmc}`"
                        :value="`${item.jlxdm}-${item.dwmc}`"></el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="详细地址" prop="area">
                  <el-col :span="24">
                    <el-autocomplete ref="autocomplete" style="width:100%" v-model.trim="areaform.area"
                      :fetch-suggestions="querySearchAsync" @change="querySearchAsync" :trigger-on-focus="true"
                      placeholder="" @select="handleSelect" @input="handleTo" @blur="handleBlur" v-scrollLoad="more1"
                      value-key="dzqc">
                    </el-autocomplete>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div style="color:#FE5C83;padding:5px 30px 10px 30px;">
                  注：涉及到多间房屋的营业场所地址可以选择到大门牌号;选项中没有对应地址的请联系辖区派出所;增加地址后再重新填报提交信息
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-row type="flex" class="title">
                <img src="@/assets/img/tag.png" alt="">
                <span class="title_text">房屋基本信息</span>
              </el-row>
              <el-col :span="6">
                <el-form-item label="房屋类别" prop="hi_fwlb">
                  <el-col>
                    <el-select v-model="areaform.hi_fwlb" placeholder="" style="width:100%">
                      <el-option v-for="item in fwlbData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="房屋面积" prop="hi_fwmj">
                  <el-col>
                    <el-input v-model="areaform.hi_fwmj">
                      <i slot="suffix" class="zzdw">m²</i>
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="房屋性质" prop="hi_fwxz">
                  <el-col>
                    <el-select v-model="areaform.hi_fwxz" placeholder="" style="width:100%">
                      <el-option v-for="item in fwxzData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="房屋间数" prop="hi_fwjs">
                  <el-col>
                    <el-input v-model="areaform.hi_fwjs">
                      <i slot="suffix" class="zzdw">间</i>
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="房屋用途" prop="hi_fwyt">
                  <el-col>
                    <el-select v-model="areaform.hi_fwyt" placeholder="" style="width:100%">
                      <el-option v-for="item in fwytData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="产权证号" prop="hi_cqzh">
                  <el-col>
                    <el-input v-model="areaform.hi_cqzh"> </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="房屋现状" prop="hi_fwzt">
                  <el-col>
                    <el-select v-model="areaform.hi_fwzt" placeholder="" style="width:100%">
                      <el-option v-for="item in fwztData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="房屋结构" prop="hi_fwjg">
                  <el-col>
                    <el-select v-model="areaform.hi_fwjg" placeholder="" style="width:100%">
                      <el-option v-for="item in fwjgData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="是否出租" prop="hi_sfcz">
                <el-col>
                  <el-radio-group v-model="areaform.hi_sfcz">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="是否注销" prop="hi_sfzx">
                <el-col>
                  <el-radio-group v-model="areaform.hi_sfzx">
                    <el-radio :label="0">正常</el-radio>
                    <el-radio :label="1">注销</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="房主/托管人" prop="fz">
                <el-col>
                  <el-checkbox-group v-model="fz">
                    <!-- @change="handleClick(city)" -->
                    <el-checkbox v-for="city in cities" :label="city.rolename" :key="city.roleid">{{ city.rolename }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-col>
              </el-form-item>
            </el-row>
            <el-divider></el-divider>
            <el-row v-show="roomVisible ? true : false">
              <el-row type="flex" class="title">
                <img src="@/assets/img/tag.png" alt="">
                <span class="title_text">房主信息</span>
              </el-row>
              <div style="height:62px">
                <el-col :span="6">
                  <el-form-item label="证件类型" :prop="roomVisible == false ? '' : 'hi_fz_zjlx'">
                    <el-col>
                      <el-select v-model="areaform.hi_fz_zjlx" placeholder="" style="width:100%">
                        <el-option v-for="item in certypeData" :key="item.code" :label="item.title" :value="item.code">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证件号码" :prop="roomVisible == false ? '' : 'hi_fz_zjhm'">
                    <el-col>
                      <el-input v-model="areaform.hi_fz_zjhm"> </el-input>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="房主姓名" :prop="roomVisible == false ? '' : 'hi_fz_xm'">
                    <el-col>
                      <el-input v-model="areaform.hi_fz_xm"> </el-input>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系方式" :prop="roomVisible == false ? '' : 'hi_fz_lxdh'">
                    <el-col>
                      <el-input v-model="areaform.hi_fz_lxdh"> </el-input>
                    </el-col>
                  </el-form-item>
                </el-col>
              </div>
              <el-divider></el-divider>
            </el-row>

            <el-row v-show="tgrVisible ? true : false">
              <el-row type="flex" class="title">
                <img src="@/assets/img/tag.png" alt="">
                <span class="title_text">托管人信息</span>
              </el-row>
              <el-col :span="6">
                <el-form-item label="证件类型" :prop="tgrVisible == false ? '' : 'hi_tgr_zjlx'">
                  <el-col>
                    <el-select v-model="areaform.hi_tgr_zjlx" placeholder="" style="width:100%">
                      <el-option v-for="item in certypeData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="与房主关系" :prop="tgrVisible == false ? '' : 'hi_tgr_yfzgx'">
                  <el-col>
                    <el-select v-model="areaform.hi_tgr_yfzgx" placeholder="" style="width:100%">
                      <el-option v-for="item in yfzgxData" :key="item.code" :label="item.title" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件号码" :prop="tgrVisible == false ? '' : 'hi_tgr_zjhm'">
                  <el-col>
                    <el-input v-model="areaform.hi_tgr_zjhm"> </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="托管人姓名" :prop="tgrVisible == false ? '' : 'hi_tgr_xm'">
                  <el-col>
                    <el-input v-model="areaform.hi_tgr_xm"> </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式" :prop="tgrVisible == false ? '' : 'hi_tgr_lxdh'">
                  <el-col>
                    <el-input v-model="areaform.hi_tgr_lxdh"> </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </div>
      <div style="text-align:center">
        <el-button type="info" size="default" @click="$router.back(-1)">返回</el-button>
        <el-button type="primary" size="default" @click="sub('areaform')">确认</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  regular,
  // CheckLicense,
  // CheckSocialCreditCode,
  // CheckOrganization,
  // CheckZongjiao,
  dzqc
} from '@/utils/validate'
import { lists } from '@/utils/dictionary.js'
import *as user from '@/api/user'
export default {
  name: 'SetStandardVue',
  data() {
    return {
      breadcrumbList: [ // 面包屑所需数据
        { name: '企业信息', path: 'enterprise_information' },
        { name: '场所标准地址', path: 'enterprise_information/set_standard' },
      ],
      statu: '',
      loading: true,
      areaform: {
        area: '',
        jlx: '',
        xzqh: '',
        hi_jlxbm: '',
        hi_xzqhbm: '',
        hi_sfcz: 1,
        hi_sfzx: 0,
        hi_fwlb: '',
        hi_fwxz: '',
        hi_fwyt: '',
        hi_fwzt: '',
        hi_fwmj: '',
        hi_cqzh: '',
        hi_fwjs: '',
        hi_fwjg: '',
        hi_fz_zjlx: '',
        hi_fz_zjhm: '',
        hi_fz_xm: '',
        hi_fz_lxdh: '',
        hi_tgr_zjlx: '',
        hi_tgr_zjhm: '',
        hi_tgr_xm: '',
        hi_tgr_lxdh: '',
        hi_tgr_yfzgx: '',
      },
      changeInfo: {},
      pno: 1,
      status: false,
      roomVisible: true,
      tgrVisible: true,
      cities: [
        { roleid: 1, rolename: '房主' },
        { roleid: 2, rolename: '托管人' }
      ],
      xzqhList: [],
      hi_xzqhbm: '',
      xzqhdm: '',
      dialog_input: '',
      roadVisible: false,
      jlxList: [],
      pgsList: [],
      hi_jlxbm: '',
      jlxdm: '',
      jlxmc: '',
      pgsVisible: false,
      area: '',
      pno1: 1,
      pgisdzqc: '',
      csList: [],
      jyztData: [],
      xfdjData: [],
      dwxzData: [],
      dwlbData: [],
      zzlxData: [],
      zTitle: '社会统一信用代码',
      ylcslbData: [],
      fwlbData: [],
      fwxzData: [],
      fwytData: [],
      fwztData: [],
      fwjgData: [],
      certypeData: [],
      yfzgxData: [],
      cs_jyztdm: '',
      JxcsName: 'jxcs',
      arr: 'tyshxydm',
      yyzp: 'yzzz_zp',
      hi_fz_zjlx: 'hi_fz_zjlx',
      dialogState: false,
      fz: ['房主', '托管人'],
      arearules: {
        area: [
          { required: true, message: '请选择详细地址', trigger: 'change' },
          {
            validator: dzqc
          }
        ],
        jlx: [{ required: true, message: '请选择街道巷', trigger: 'change' }],
        hi_xzqhbm: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        hi_fwlb: [
          { required: true, message: '请选择房屋类别', trigger: 'change' }
        ],
        hi_fwxz: [
          { required: true, message: '请选择房屋性质', trigger: 'change' }
        ],
        hi_fwyt: [
          { required: true, message: '请选择房屋用途', trigger: 'change' }
        ],
        hi_fwzt: [
          { required: true, message: '请选择房屋现状', trigger: 'change' }
        ],
        hi_fwmj: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('房屋面积必须为数字'))
                } else if (/^[0-9]{1,5}$/.test(value) == false) {
                  callback(new Error('房屋面积长度不得超过5'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],
        hi_fwjs: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('房屋间数必须为数字'))
                } else if (/^[0-9]{1,4}$/.test(value) == false) {
                  callback(new Error('房屋间数长度不得超过4'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],
        hi_cqzh: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('产权证号必须为数字'))
                } else if (/^[0-9]{1,20}$/.test(value) == false) {
                  callback(new Error('产权证号长度不得超过20'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],

        hi_fz_zjlx: [
          { required: true, message: '请选择房主证件类型', trigger: 'change' }
        ],

        hi_fz_zjhm: [
          { required: true, message: '请输入房主证件号码', trigger: 'blur' },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的房主证件号码',
            trigger: 'blur'
          }
        ],
        hi_fz_xm: [
          { required: true, message: '请输入房主姓名', trigger: 'blur' },
          {
            max: 10,
            message: '房主姓名长度不得超过10',
            trigger: 'blur'
          }
        ],
        hi_fz_lxdh: [
          { required: true, message: '请输入房主联系电话', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的房主联系电话',
            trigger: 'blur'
          }
        ],
        hi_tgr_zjlx: [
          { required: true, message: '请选择托管人证件类型', trigger: 'change' }
        ],
        hi_tgr_zjhm: [
          {
            required: true,
            message: '请输入托管人证件号码',
            trigger: 'change'
          },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的托管人证件号码',
            trigger: 'blur'
          }
        ],
        hi_tgr_xm: [
          { required: true, message: '请输入托管人姓名', trigger: 'blur' },
          {
            max: 10,
            message: '托管人姓名长度不得超过10',
            trigger: 'blur'
          }
        ],
        hi_tgr_lxdh: [
          { required: true, message: '请输入托管人联系电话', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的托管人联系电话',
            trigger: 'blur'
          }
        ],
        hi_tgr_yfzgx: [
          {
            required: true,
            message: '请选择托管人与房主关系',
            trigger: 'change'
          }
        ]
      },
    }
  },
  created() {
    this.statu = this.$store.getters.status
  },
  async mounted() {
    if (this.$store.getters.status !== 3) {
      const res = await user.getEnterpriseDetails(this.$store.state.user.userInfo.place_id)
      this.areaform = res.gethouseinfo
      const arr = res.gethouseinfo.hi_content.split('-')
      console.log(arr);
      this.areaform.jlx = `${arr[3]}-${res.gethouseinfo.hi_dwmc}`
      this.areaform.area = res.gethouseinfo.hi_dzmc
      this.jlxdm = this.areaform.jlxdm
      this.jlxmc = this.areaform.jlxmc
      if (this.areaform.hi_is_fz && this.areaform.hi_is_tgr) {
        this.fz = ['房主', '托管人']
      } else if (this.areaform.hi_is_fz && !this.areaform.hi_is_tgr) {
        this.fz = ['房主']
      } else if (!this.areaform.hi_is_fz && this.areaform.hi_is_tgr) {
        this.fz = ['托管人']
      } else if (!this.areaform.hi_is_fz && !this.areaform.hi_is_tgr) {
        this.fz = []
      }
      this.getArea()
      this.getXzqh()
      this.getFwlb()
      this.getFwxz()
      this.getFwyt()
      this.getFwzt()
      this.getFwjg()
      this.getZjlx()
      this.getfzgx()

    } else {
      this.getXzqh()
      this.getFwlb()
      this.getFwxz()
      this.getFwyt()
      this.getFwzt()
      this.getFwjg()
      this.getZjlx()
      this.getfzgx()

    }

  },
  methods: {
    handleMap() {
      this.pno = 1
      this.jlxList = []
      this.pgsList = []
      this.getJlx()
      this.areaform.jlx = ''
      this.areaform.area = ''
    },
    more() {
      this.pno++
      this.getJlx()
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        // setTimeout(async () => {
        const data = await user.getJlx({
          xzqh: this.areaform.hi_xzqhbm,
          pno: 1,
          prefixtext: query
        })
        console.log(data)
        this.jlxList = data.datas
        // }, 200)
      }
      // else {
      //   this.options = []
      // }
    },
    async getJlx() {
      const res = await user.getJlx({ xzqh: this.areaform.hi_xzqhbm, pno: this.pno })
      console.log(res);
      this.jlxList.push(...res.datas)
    },
    Pgs(val) {
      console.log('val', val);
      this.jlxmc = val.split('-')[1]
      this.jlxdm = val.split('-')[0]
      this.pno1 = 1
      this.pgsList = []
      this.getPgs()
      this.areaform.area = ''
      this.$forceUpdate()
    },
    async getPgs() {
      const data = await user.getArea({
        jlx: this.jlxdm,
        pno: this.pno1
      })
      console.log(data)
      this.pgsList.push(...data.datas)
    },
    async more1() {
      this.pno1++

      const data = await user.getArea({
        jlx: this.jlxdm,
        prefixtext: this.areaform.area,
        pno: this.pno1
      })

      this.pgsList.push(...data.datas)

      this.$refs['autocomplete'].$data.suggestions.push(...data.datas)
    },
    async querySearchAsync(queryString, cb) {
      console.log('queryString', queryString);
      this.pno1 = 1
      if (!this.areaform.jlx) {
        this.jlxdm = ''
        this.pgsList = []
      }
      if (!this.areaform.area) {
        if (!queryString) {
          let List = []
          console.log(this.pgsList)
          this.pgsList.forEach(e => {
            var obj = {}
            obj.value = e.dzqc
            obj.dzdm = e.dzdm
            obj.dzqc = e.dzqc
            obj.pgisdzqc = e.pgisdzqc
            List.push(obj)
          })
          cb(List)
        } else {
          const data = await user.getArea({
            jlx: this.jlxdm,
            pno: 1,
            prefixtext: queryString
          })
          this.pgsList = data.datas
          let List = []
          this.pgsList.forEach(e => {
            var obj = {}
            obj.value = e.dzqc
            obj.dzdm = e.dzdm
            obj.dzqc = e.dzqc
            obj.pgisdzqc = e.pgisdzqc
            List.push(obj)
          })
          cb(List)
          if (this.pgsList.length <= 1) {
            this.status = true
          } else {
            this.status = false
            this.$refs.autocomplete.$refs.input.focus()
          }
        }
      } else {
        const data = await user.getArea({
          jlx: this.jlxdm,
          pno: 1,
          prefixtext: this.areaform.area
        })
        this.pgsList = data.datas
        console.log('pgs', data)
        let List = []
        this.pgsList.forEach(e => {
          var obj = {}
          obj.value = e.dzqc
          obj.dzdm = e.dzdm
          obj.dzqc = e.dzqc
          obj.pgisdzqc = e.pgisdzqc
          List.push(obj)
        })
        console.log('00000', List)
        this.areaform.hi_content = List[0].pgisdzqc
        cb(List)
        if (this.pgsList.length <= 1) {
          this.status = true
        } else {
          this.status = false
          this.$refs.autocomplete.$refs.input.focus()
        }
      }
      this.$forceUpdate()

    },
    handleSelect(item) {
      this.pgisdzqc = item.pgisdzqc
      this.$refs.autocomplete.$refs.input.focus()
    },
    handleTo() {
      this.pgisdzqc = ''
      this.$set(this.areaform, 'area', '')
      // this.areaform.area = ''
    },
    handleBlur() {
      if (!this.pgisdzqc) {
        this.areaform.area = ''
      }
    },
    async getArea() {
      const { data, status, } = await user.getArea()
      if (status === 1) {
        this.areaList = data
      } else {
        // this.$message.error(msg)
      }
    },
    async getXzqh() {
      this.xzqhList = lists['XAXZQH']
    },
    async getFwlb() {
      this.fwlbData = lists['FWLB']
    },
    async getFwxz() {
      this.fwxzData = lists['FWXZH']
    },
    async getFwyt() {
      this.fwytData = lists['FWYT']
    },
    async getFwzt() { //房屋现状
      this.fwztData = lists['FWXZ']
    },
    async getFwjg() {
      this.fwjgData = lists['FWJG']
    },

    async getZjlx() {
      this.certypeData = lists['ZJLX']
    },
    async getfzgx() {
      this.yfzgxData = lists['YBRGX']
    },
    sub() {
      this.$refs.areaform.validate(valid => {
        if (valid) {
          this.changeInfo.hi_content = this.areaform.hi_content
          this.changeInfo.hi_dwmc = this.jlxmc

          this.changeInfo.hi_xzqhbm = this.areaform.hi_xzqhbm
          this.changeInfo.hi_jlx = this.areaform.hi_jlxbm
          this.changeInfo.hi_dzmc = this.areaform.area
          this.changeInfo.hi_fwlb = this.areaform.hi_fwlb
          this.changeInfo.hi_fwxz = this.areaform.hi_fwxz
          this.changeInfo.hi_fwyt = this.areaform.hi_fwyt
          this.changeInfo.hi_fwzt = this.areaform.hi_fwzt
          this.changeInfo.hi_fwmj = this.areaform.hi_fwmj
          this.changeInfo.hi_fwjs = this.areaform.hi_fwjs
          this.changeInfo.hi_cqzh = this.areaform.hi_cqzh
          this.changeInfo.hi_fwjg = this.areaform.hi_fwjg
          this.changeInfo.hi_sfcz = this.areaform.hi_sfcz
          this.changeInfo.hi_sfzx = this.areaform.hi_sfzx
          this.changeInfo.hi_is_fz = this.roomVisible ? '1' : '0'
          this.changeInfo.hi_is_tgr = this.tgrVisible ? '1' : '0'


          this.changeInfo.hi_fz_zjlx = this.areaform.hi_fz_zjlx
          this.changeInfo.hi_fz_zjhm = this.areaform.hi_fz_zjhm
          this.changeInfo.hi_fz_xm = this.areaform.hi_fz_xm
          this.changeInfo.hi_fz_lxdh = this.areaform.hi_fz_lxdh

          this.changeInfo.hi_tgr_zjlx = this.areaform.hi_tgr_zjlx
          this.changeInfo.hi_tgr_zjhm = this.areaform.hi_tgr_zjhm
          this.changeInfo.hi_tgr_xm = this.areaform.hi_tgr_xm
          this.changeInfo.hi_tgr_lxdh = this.areaform.hi_tgr_lxdh
          this.changeInfo.hi_tgr_yfzgx = this.areaform.hi_tgr_yfzgx

          // 将changeInfo传递
          console.log('changeInfo', this.changeInfo)
          user.saveInfoHouse(this.changeInfo).then(res => {
            console.log(res)
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            })
            this.$router.push('/enterprise_information/set_enterprise')
          })

        }
      })


    },
  },
  watch: {
    fz(valArr) {
      if (valArr.length == 0) {
        this.tgrVisible = false

        this.areaform.hi_tgr_zjlx = ''
        this.areaform.hi_tgr_zjhm = ''
        this.areaform.hi_tgr_xm = ''
        this.areaform.hi_tgr_lxdh = ''
        this.areaform.hi_tgr_yfzgx = ''
        this.roomVisible = false
        this.areaform.hi_fz_zjlx = ''
        this.areaform.hi_fz_zjhm = ''
        this.areaform.hi_fz_xm = ''
        this.areaform.hi_fz_lxdh = ''
      }
      this.fz.filter(i => {
        console.log(i)
        if (valArr.length == 2) {
          this.tgrVisible = true
          this.roomVisible = true
        } else if (valArr.length == 1) {
          if (i == '托管人') {
            this.tgrVisible = true
          } else {
            this.tgrVisible = false
            this.areaform.hi_tgr_zjlx = ''
            this.areaform.hi_tgr_zjhm = ''
            this.areaform.hi_tgr_xm = ''
            this.areaform.hi_tgr_lxdh = ''
            this.areaform.hi_tgr_yfzgx = ''
          }
          if (i == '房主') {
            this.roomVisible = true
          } else {
            this.roomVisible = false
            this.areaform.hi_fz_zjlx = ''
            this.areaform.hi_fz_zjhm = ''
            this.areaform.hi_fz_xm = ''
            this.areaform.hi_fz_lxdh = ''
          }
        } else {
          this.tgrVisible = false
          this.areaform.hi_tgr_zjlx = ''
          this.areaform.hi_tgr_zjhm = ''
          this.areaform.hi_tgr_xm = ''
          this.areaform.hi_tgr_lxdh = ''
          this.areaform.hi_tgr_yfzgx = ''
          this.roomVisible = false
          this.areaform.hi_fz_zjlx = ''
          this.areaform.hi_fz_zjhm = ''
          this.areaform.hi_fz_xm = ''
          this.areaform.hi_fz_lxdh = ''
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.main {
  margin: 20px;

  .title {
    margin-bottom: 31px;
  }

  .title_text {
    font-size: 18px;
    line-height: 36px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #6345d5;
  }

  .zzdw {
    margin-right: 12px;
    font-size: 12px;
    color: #6345d5;
    font-style: normal;
  }

  .ybsh {
    position: relative;

    .ybsh_tag {
      position: absolute;
      top: 11px;
      right: 13px;
      width: 50px;
      height: 22px;
      border-radius: 11px;
      background: #edebf6;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #6345d5;
    }
  }

  /deep/ .areaform {
    .el-form {
      text-align: left;
    }

    .el-input__inner {
      height: 35px !important;
      line-height: 35px !important;
    }

    .el-form-item {
      margin-bottom: 15px !important;
    }

    .el-dialog {
      margin-top: 20px !important;
      width: 90% !important;

      .el-dialog__header {
        text-align: center;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #000;
        // color: #303133;
        text-align: center;
        font-weight: bold;
      }
    }
  }
}
</style>>